import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import 'react-spring-bottom-sheet/dist/style.css';
import './styles/main.scss';
import {Provider} from 'react-redux';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {store} from './store/store';
import {initAppErrorLogger} from './utils/sentry/sentry';

initAppErrorLogger();

const queryClient: QueryClient = new QueryClient();

ReactDOM.render(
    <StrictMode>
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </Provider>
    </StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
